import { z } from 'zod';

// GB #1719: React-free carrier schema, kept inside @gearfocus/types so the
// package has no runtime dependency on the web app's src/ tree (2026-08-16
// fix — the package previously imported this file via a relative path
// reaching up into the web app's src/ tree, which broke `apps/mobile`
// bundling and any consumer that doesn't have GearFocus web's src/
// directory on disk). Canonical location is here; src/utils/maps/
// carrierCode.ts re-exports this file so existing web consumers (carriers.tsx,
// order.ts's old resolution path, etc.) keep working unmodified.
const carrierCodeSchemas = [
  z.literal('usps'),
  z.literal('fedex'),
  z.literal('ups'),
  z.literal('dhl_express'),
  z.literal('dhl_global_mail'),
  z.literal('canada_post'),
  z.literal('australia_post'),
  z.literal('firstmile'),
  z.literal('asendia'),
  z.literal('ontrac'),
  z.literal('apc'),
  z.literal('newgistics'),
  z.literal('globegistics'),
  z.literal('rr_donnelley'),
  z.literal('imex'),
  z.literal('access_worldwide'),
  z.literal('purolator_ca'),
  z.literal('sendle'),
] as const;

export const carrierCodeSchema = z.union(carrierCodeSchemas);

export const carrierSchema = z.object({
  name: z.string(),
  code: carrierCodeSchema,
  icon: z.any().optional(),
});

export type CarrierCode = z.infer<typeof carrierCodeSchema>;

export type Carrier = z.infer<typeof carrierSchema>;
